import React from 'react';
import { Badge } from './ui/badge';
import { Award, Briefcase, Calendar } from 'lucide-react';
import { experience } from '../data/mock';

const Experience = () => {
  return (
    <section id="experience" className="py-20 bg-slate-950">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Professional Experience
          </h2>
          <p className="text-slate-400 text-lg">
            Building quality software and automation solutions
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {experience.map((exp) => (
            <div
              key={exp.id}
              className="bg-slate-800/50 rounded-xl p-8 border border-slate-700 hover:border-teal-500/50 transition-all duration-300 hover:shadow-xl hover:shadow-teal-500/10"
            >
              {/* Header */}
              <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
                <div>
                  <h3 className="text-2xl font-bold text-white mb-2">{exp.position}</h3>
                  <div className="flex items-center gap-2 text-teal-400 text-lg mb-2">
                    <Briefcase className="w-5 h-5" />
                    <span className="font-semibold">{exp.company}</span>
                  </div>
                  <div className="flex items-center gap-2 text-slate-400">
                    <Calendar className="w-4 h-4" />
                    <span>{exp.duration}</span>
                    <Badge variant="secondary" className="ml-2 bg-slate-700 text-slate-300">
                      {exp.type}
                    </Badge>
                  </div>
                </div>
              </div>

              {/* Awards */}
              {exp.awards && exp.awards.length > 0 && (
                <div className="mb-6 p-4 bg-teal-500/5 border border-teal-500/20 rounded-lg">
                  <div className="flex items-center gap-2 mb-3">
                    <Award className="w-5 h-5 text-teal-400" />
                    <h4 className="text-lg font-semibold text-teal-400">Awards & Recognition</h4>
                  </div>
                  <div className="space-y-2">
                    {exp.awards.map((award, index) => (
                      <div key={index} className="flex items-start gap-2">
                        <span className="text-teal-400 mt-1">🏆</span>
                        <span className="text-slate-200 font-medium">{award}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Achievements */}
              <div>
                <h4 className="text-lg font-semibold text-white mb-4">Key Achievements & Responsibilities</h4>
                <ul className="space-y-3">
                  {exp.achievements.map((achievement, index) => (
                    <li key={index} className="flex items-start gap-3 text-slate-300">
                      <span className="text-teal-400 mt-1 flex-shrink-0">▸</span>
                      <span>{achievement}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
